"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const encoding_1 = require("@iov/encoding");
const constants_1 = require("./constants");
function encodeInt(intNumber) {
    if (!Number.isInteger(intNumber)) {
        throw new Error("Received some kind of number that can't be encoded.");
    }
    // Normalizes the zero value to null as expected by weave
    return intNumber || null;
}
exports.encodeInt = encodeInt;
function encodeString(data) {
    // Normalizes the empty string to null as expected by weave
    return data || null;
}
exports.encodeString = encodeString;
function encodeAmount(amount) {
    if (amount.fractionalDigits !== constants_1.weaveFractionalDigits) {
        throw new Error(`Fractional digits must be ${constants_1.weaveFractionalDigits} but was ${amount.fractionalDigits}`);
    }
    const whole = encoding_1.Int53.fromString(amount.quantity.slice(0, -amount.fractionalDigits) || "0");
    const fractional = encoding_1.Int53.fromString(amount.quantity.slice(-amount.fractionalDigits) || "0");
    return {
        whole: encodeInt(whole.toNumber()),
        fractional: encodeInt(fractional.toNumber()),
        ticker: encodeString(amount.tokenTicker),
    };
}
exports.encodeAmount = encodeAmount;
function encodeNumericId(id) {
    return encoding_1.Uint64.fromNumber(id).toBytesBigEndian();
}
exports.encodeNumericId = encodeNumericId;
//# sourceMappingURL=encodinghelpers.js.map